// @flow
import * as React from 'react';
import { injectIntl } from 'react-intl';
// eslint-disable-next-line import/named
import type { IntlShape } from 'react-intl';

import { Button } from 'components/atoms/';
import './SocialLoginButton.scss';
import img from './img';

type Props = {
  /**
   * The social login provider, since the number of social
   * providers is highly unlikely to increase dramatically
   * there's a single social login button component that'll represent
   * all of them
   */
  provider: 'facebook' | 'google',
  children: string,
  intl: IntlShape
};

const SocialLoginButton = ({ provider, children, intl, ...props }: Props) => {
  const ns = SocialLoginButton.block;
  let alt;
  let ariaLabel;

  // TODO: remove default messages once localization strings are ready
  if (provider === 'google') {
    alt = intl.formatMessage({
      id: 'c8.aria.google.sign.in',
      defaultMessage: 'Google sign in button'
    });
    ariaLabel = intl.formatMessage({
      id: 'c8.aria.sign.in.with.google.account',
      defaultMessage: 'Sign In with Google account'
    });
  } else {
    alt = intl.formatMessage({
      id: 'c8.aria.facebook.sign.in',
      defaultMessage: 'Facebook sign in button'
    });
    ariaLabel = intl.formatMessage({
      id: 'c8.aria.sign.in.with.facebook',
      defaultMessage: 'Sign In with Facebook'
    });
  }

  return (
    <Button className={ns} buttonTheme="action" {...props} tabIndex={0}>
      <img
        className={`${ns}--image`}
        src={img[provider]}
        alt={alt}
        aria-hidden={true}
      />
      {/* the text below is static, i.e. no i18n is required */}
      <span aria-label={ariaLabel}>{children}</span>
    </Button>
  );
};

SocialLoginButton.block = 'social-login-button';

export default injectIntl(SocialLoginButton);



// WEBPACK FOOTER //
// ./src/components/pages/User/Social/SocialLoginButton/SocialLoginButton.js